import React from "react";

const AsHtml = ({ content }) => {
    if (content)
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: content,
                }}
            ></div>
        );

    return null;
};

export default AsHtml;
